// import Vue from 'vue'

export const bastards = {
    install: function (Vue) {
        /**
         * Bastards method - inserts non breaking space between single chars
         *
         * @param value
         * @returns {*}
         */
        let bastards = function (value) {
            if (value === undefined || value === null) {
                return
            }

            value = value.replace(/(\s)([\S])[\s]+/g, '$1$2&nbsp;')
            value = value.replace(/(\s)([^<][\S])[\s]+/g, '$1$2&nbsp;')
            value = value.replace(/(\s)([\S]{1,2})$/g, '&nbsp;$2')

            return value
        }

        Vue.filter('bastards', bastards)

        Vue.directive('bastards', function (element) {
            element.innerHTML = bastards(element.innerHTML)
        })
    }
}
